export interface UiState {
  isContentLoading: boolean;
  isModalLoading?: boolean;
  isUserIdle?: boolean;
  portalMode?: number | undefined;
}

export const initialUiState: UiState = {
  isContentLoading: false,
  isModalLoading: false,
  isUserIdle: false,
  portalMode: undefined,
};
